<h1 class="matp-page-title">位置情報設定</h1>

<div class="tw-flex tw-gap-4 tw-h-[calc(100%_-_100px)]">
  <!-- 位置情報一覧 -->
  <mat-card class="matp-card tw-h-fit tw-w-[60%]">
    <app-shipment-location-list-table
      [locationList]="locationList"
      (created)="openShipmentLocationEditDialog()"
      (updated)="openShipmentLocationEditDialog($event)"
      (selected)="onSelectedLocation($event)"
      (deleted)="deleteLocations($event)"
      (exportCsv)="exportToCsv()"
      (imported)="openShipmentLocationImportDialog()"
    >
    </app-shipment-location-list-table>
  </mat-card>

  <!-- マップ -->
  <div class="tw-h-full tw-flex-1 tw-min-w-[600px]">
    <app-shipment-location-map
      [location]="selectedLocation"
    ></app-shipment-location-map>
  </div>
</div>
